import { Button, Input, Result, Form } from 'antd'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../redux/context/company/selectors'
import { useBackend } from '../../../../../services/backend'
import { useIntegrationDocsURL } from '../../../../../utils/docs'
import DataUpdate from '../dataUpdate'
import { AppDispatch } from '../../../../../redux/store'
import { notificationAction } from '../../../../../redux/middleware/actions'

const NetSuite: React.FC = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()
  const companyId = useSelector(contextCompanyIdSelector)
  const getCredentials = useBackend(`/netsuite/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)
  const setCredentials = useBackend(`/netsuite/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)

  const dispatch: AppDispatch = useDispatch()

  const [form] = Form.useForm()
  const [authorized, setAuthorized] = useState(false)

  const getCredentialsHandler = () => {
    getCredentials
      .get({
        urlParams: { companyId }
      })
      .then(() => {
        setAuthorized(true)
      })
      .catch(() => {
        setAuthorized(false)
      })
  }

  useEffect(getCredentialsHandler, [companyId])

  const submit = () => {
    form
      .validateFields()
      .then(data => {
        setCredentials
          .put({
            urlParams: { companyId },
            body: { data }
          })
          .then(() => {
            setAuthorized(true)
            dispatch(
              notificationAction({
                type: 'success',
                message: 'AUTHENTICATION_SUCCESS',
                description: 'IMPORT_SUCCESS_EMAIL'
              })
            )
          })
          .catch(() => {
            setAuthorized(false)
            dispatch(
              notificationAction({
                type: 'error',
                message: 'AUTHENTICATION_ERROR',
                description: 'USERNAME_PASSWORD_MISMATCH'
              })
            )
          })
      })
      .catch(() => {
        // Form validation failed, do nothing
      })
  }

  const emptyCredentials = () => {
    form.resetFields()
    setAuthorized(false)
  }

  if (authorized) {
    return (
      <>
        <Result
          status="success"
          title={t('integrationsPage:authenticated')}
          extra={
            <>
              <Button onClick={emptyCredentials} type="primary">
                {t('integrationsPage:authenticate')}
              </Button>
              <DataUpdate page="netsuite" />
            </>
          }
        />
      </>
    )
  }
  return (
    <Form form={form} layout="vertical">
      <a href={integrationDocs.accounting('netsuite')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Form.Item
        style={{ marginTop: 10 }}
        label="Client ID"
        name="clientId"
        rules={[{ required: true, message: 'Client ID is required' }]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item label="Account ID" name="accountId" rules={[{ required: true, message: 'Account ID is required' }]}>
        <Input.Password />
      </Form.Item>
      <Form.Item
        label="Certificate ID"
        name="certificateId"
        rules={[{ required: true, message: 'Certificate ID is required' }]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item label="Private Key" name="privateKey" rules={[{ required: true, message: 'Private Key is required' }]}>
        <Input.Password />
      </Form.Item>
      <Form.Item label="Subsidiary ID" name="subsidiaryId">
        <Input />
      </Form.Item>
      <Form.Item>
        <Button type="primary" onClick={() => submit()}>
          {t('integrationsPage:authorize')}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default NetSuite
